/**
 * Job application attribution (RFC-2026-007).
 * Add new sources, mediums, or campaigns here when extending channels/campaigns.
 */

/** Attribution source (e.g. referral, linkedin). */
export const AttributionSource = {
  REFERRAL: 'referral',
  // FUTURE: LINKEDIN: 'linkedin', CAMPAIGN: 'campaign',
} as const;

export type AttributionSourceValue =
  (typeof AttributionSource)[keyof typeof AttributionSource];

/** Attribution medium (e.g. job_page, email, social). */
export const AttributionMedium = {
  JOB_PAGE: 'job_page',
  // FUTURE: EMAIL: 'email', SOCIAL: 'social',
} as const;

export type AttributionMediumValue =
  (typeof AttributionMedium)[keyof typeof AttributionMedium];

/** Attribution campaign (e.g. referrer identifier, named campaigns). */
export const AttributionCampaign = {
  REFERRER_IDENTIFIER: 'referrer_identifier',
  // FUTURE: SPRING_2026: 'spring_hiring_2026', FALL_2026: 'fall_hiring_2026',
} as const;

export type AttributionCampaignValue =
  (typeof AttributionCampaign)[keyof typeof AttributionCampaign];
